module.exports = __webpack_public_path__ + "static/media/bird.27bbd48d.svg";